import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import Image from '../global/Image';

export default class PageText extends Component {
    
	render () {
		
		let block 	= this.props.block;
		
		if (block) {
		
			
		    return (
		        
		        <div id={block.id} className={'c-page__block c-page__block--' + block.background_colour}>
		        	
		        	<div className="c-text-carousel">
		        	
		        		<div className="l-grid c-text-carousel__inner">
		        		
		        			<div className="l-grid__col l-grid__col--l-6-12">
		        			
		        				<header className="c-text-carousel__header">
		        					<h1 className="c-heading">
		        						<span className="c-heading__line">
		        							<span className="c-heading__line__inner" dangerouslySetInnerHTML={{ __html:block.heading }}></span>
		        						</span>
		        					</h1>
		        				</header>
		        				
		        			</div>
		        				
		        			<div className="l-grid__col l-grid__col--l-6-12">
		        				
		        				{block.introduction &&
		        					<div className="c-text-carousel__intro scope-large-text c-load-fade" dangerouslySetInnerHTML={{ __html:block.introduction }}></div>
		        				}
		        				
		        				<div className="c-text-carousel__text">
			        				<div className="scope-extend-text c-load-fade" dangerouslySetInnerHTML={{ __html:block.text }}></div>			        			
		        				</div>
		        				
		        			</div>
		        		
		        		</div>
		        		
		        	</div>
		        	
		        </div>      	
			        	
			)
			
		} else {
			
			return null;
		
		}
	}
}
